export interface BuildAvatarParams {
  avatar_url?: string | null;
  avatar_path?: string | null;
  legacy?: string | null;
  windowOrigin?: string;
}

export const buildAvatarSrc = (
  params: BuildAvatarParams | string | null = {},
): string => {
  const p = typeof params === "string" ? { avatar_url: params } : params || {};
  const { avatar_url, avatar_path, legacy, windowOrigin } =
    p as BuildAvatarParams;
  const normalize = (v?: string | null) => (v ? v.replace(/\\\//g, "/") : "");
  const aUrl = normalize(avatar_url);
  const aPath = normalize(avatar_path);
  const legacyPath = normalize(legacy);

  const origin = ((): string => {
    if (windowOrigin) return windowOrigin;
    if (typeof window !== "undefined") return window.location.origin;
    return "";
  })();

  const apiImageOrigin = ((): string => {
    if (
      typeof process !== "undefined" &&
      process.env.NEXT_PUBLIC_API_IMAGE_URL
    ) {
      return process.env.NEXT_PUBLIC_API_IMAGE_URL;
    }
    return origin;
  })();

  if (aPath) {
    if (/^https?:\/\//.test(aPath)) return aPath;
    if (aPath.startsWith("/")) return `${apiImageOrigin}${aPath}`;
    return aPath;
  }
  if (aUrl) return aUrl;
  if (legacyPath) {
    if (/^https?:\/\//.test(legacyPath)) return legacyPath;
    if (legacyPath.startsWith("/")) return `${apiImageOrigin}${legacyPath}`;
    return legacyPath;
  }
  return "";
};
